export const isChromaLegacy = name =>
  name
    ? name.trim().toLowerCase().includes('chroma') && name.trim().toLowerCase().includes('legacy')
    : false;
